import { connect } from 'react-redux';
import Contacts from './Contacts';

let mapStateToProps = (state) => {
  return {
    shopName: state.aboutPage.aboutData.shopName,
    domain: state.aboutPage.aboutData.domain,
    aboutData: state.aboutPage.aboutData,
  };
};

let mapDispatchToProps = (dispatch) => {
  return {};
};

const ContactsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Contacts);

export default ContactsContainer;
